// 立即执行函数，接收window和document作为参数
(function flexible (window, document) {
  // 获取文档的根元素
  var docEl = document.documentElement
  // 获取设备的像素比，如果没有则默认为1
  var dpr = window.devicePixelRatio || 1

  // 定义一个设置body字体大小的函数
  function setBodyFontSize () {
    // 如果文档的body元素已经存在
    if (document.body) {
      // 设置body的字体大小为12乘以设备像素比
      document.body.style.fontSize = (12 * dpr) + 'px'
    }
    // 如果body元素还不存在，监听DOMContentLoaded事件，当DOM内容加载完毕时设置字体大小
    else {
      document.addEventListener('DOMContentLoaded', setBodyFontSize)
    }
  }
  // 调用函数设置body的字体大小
  setBodyFontSize();

  // 定义一个设置根元素字体大小的函数
  function setRemUnit () {
    // 计算rem单位，为文档根元素宽度的1/10
    var rem = docEl.offsetWidth / 10
    // 设置根元素的字体大小
    docEl.style.fontSize = rem + 'px'
  }

  // 调用函数设置rem单位
  setRemUnit()

  // 监听窗口的resize事件，当窗口大小变化时重新设置rem单位
  window.addEventListener('resize', setRemUnit)
  // 监听pageshow事件，该事件在用户返回到页面时触发
  window.addEventListener('pageshow', function (e) {
    // 如果页面是从缓存中加载的
    if (e.persisted) {
      // 重新设置rem单位
      setRemUnit()
    }
  })

  // 如果设备的像素比大于等于2
  if (dpr >= 2) {
    // 创建一个假的body元素
    var fakeBody = document.createElement('body')
    // 创建一个测试元素
    var testElement = document.createElement('div')
    // 设置测试元素的边框样式
    testElement.style.border = '.5px solid transparent'
    // 将测试元素添加到假的body元素中
    fakeBody.appendChild(testElement)
    // 将假的body元素添加到文档根元素中
    docEl.appendChild(fakeBody)
    // 如果测试元素的offsetHeight为1，说明浏览器支持.5px的边框
    if (testElement.offsetHeight === 1) {
      // 给根元素添加一个hairlines类名
      docEl.classList.add('hairlines')
    }
    // 移除假的body元素
    docEl.removeChild(fakeBody)
  }
}(window, document))
